import { useMutation } from '@tanstack/react-query'
import { customSwal } from '../../../../config/swal'
import { FileService } from '../../../../services/FileService'

const getFileNameFromUrl = (url: string) => {
  const withoutQuery = url.split('?')[0]
  return withoutQuery.substring(withoutQuery.lastIndexOf('/') + 1)
}

export const useSpectrumBankAccountImageViewer = () => {
  const viewImage = (url: string) => {
    if (!url) return
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const downloadMutation = useMutation({
    mutationFn: (url: string) => FileService().downloadFromAzure(url),
    onSuccess: async (data, url) => {
      const objectUrl = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = objectUrl
      link.setAttribute('download', getFileNameFromUrl(url))

      document.body.appendChild(link)
      link.click()

      await new Promise((resolve) => setTimeout(resolve, 1000))

      document.body.removeChild(link)
      window.URL.revokeObjectURL(objectUrl)
    },
    onError: () => {
      customSwal.fire({ icon: 'error', title: 'No se pudo descargar la imagen.' })
    },
  })

  return {
    viewImage,
    downloadImage: (url: string) => downloadMutation.mutate(url),
    isDownloading: (url: string) =>
      downloadMutation.isLoading && downloadMutation.variables === url,
  }
}
